<div class="parent-container">
  <div class="text-container">
    <img alt ="logo" width="150" src="/assets/images/hsbc-brand-logo.svg"><strong></strong>
    <h1 class="mt-3">Session Expired</h1>
    <h2><a role="link" tabindex="0" (click)="goTo('')">Please log in again</a></h2>
  </div>
</div>
